import React, { useEffect, useState, useContext, useCallback } from "react";
import { useLocation, useNavigate, useParams, useOutletContext } from 'react-router-dom';
import { Card } from "../../common_components/Layout";
import { TitleAndText } from "../components/TitleAndText";
import { FormField, CommentField } from "../../common_components/Forms";
import CreationFooter from "../components/CreationFooter";
import { useAlert } from 'react-alert'
import { ResearcherContext } from "../../../../ResearcherContext";
import CreateMissionHeaderAndTitleRow from "../components/CreateMissionHeaderAndTitleRow";
import { updatePrice, PriceDisplay } from "../components/PriceDisplay";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import _ from 'lodash'; // Lodash for debouncing


// Api Calls
import MissionsAPI from "../../../api/api_calls/MissionAPI";


function MissionNameAndDetails(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [submitInProcess, setSubmitInProcess] = useState(false);
    const [loadingMission, setLoadingMission] = useState(true);

    const [missionName, setMissionName] = useState("");
    const [missionDescription, setMissionDescription] = useState("");
    const [missionType, loadingMissionType, nextPage, backPage] = [props.missionType, props.loadingMissionType, props.nextPage, props.backPage]
    const { researcher, setResearcher, refreshResearcher } = useContext(ResearcherContext);



    const nameTooltip = "The name of your project that will be shown to your users. We recommend your name implies the rough user group you are targeting without being too specific. E.g. Social Media Users, Software Developers, etc."
    const descriptionTooltip = "The description of your project that will be shown to your users. Often it's something like - 'Looking for users who are interested in cryptocurrency and social media'"


    useEffect(() => {
        // Enable tooltips

        async function getMissionDetails() {
            const result = await MissionsAPI.show(missionId, navigate);

            if (result.success) {
                result.mission.name != "Draft Mission" ? setMissionName(result.mission.name) : "";
                result.mission.audience_description != null ? setMissionDescription(result.mission.audience_description) : "";
                setLoadingMission(false);
            } else {
                alert.show(result.error, { type: 'error' })
            }
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
            const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

        }
        getMissionDetails();
    }, []);

    // API Update function.
    async function createMissionNameAndDetails({ nameData = missionName, descriptionData = missionDescription } = {}) {
        const result = await MissionsAPI.update({ missionId: missionId, name: nameData, description: descriptionData, handleRedirect: navigate });

        if (result.success) {
        } else {
            alert.show(result.error, { type: 'error' })
        }
        setSubmitInProcess(false);
    }

    const updateServerForName = useCallback(
        _.debounce(createMissionNameAndDetails, 500), [] // 500ms debounce
    );

    const updateServerForDescription = useCallback(
        _.debounce(createMissionNameAndDetails, 500), [] // 500ms debounce
    );

    function onMissionNameChange(event) {
        setMissionName(event.target.value);
        updateServerForName({ nameData: event.target.value, descripionData: missionDescription });
    }
    function onMissionDescriptionChange(event) {
        setMissionDescription(event.target.value);
        updateServerForDescription({ nameData: missionName, descriptionData: event.target.value });
    }

    function onClickBack() {
        navigate(backPage, { state: { missionId: missionId } })
    }
    function onClickSubmit(event) {
        event.preventDefault();

        // Vet the answers all make sense.
        if (missionName.length <= 0) {
            alert.show("Please create a name for your project", { type: 'error' })
            return;
        }
        if (missionDescription.length <= 0) {
            alert.show("Please add a description for your project", { type: 'error' })
            return;
        }

        // Move to the next page.
        createMissionNameAndDetails();
        navigate(nextPage, { state: { missionId: missionId } });
    }




    return (
        <div className="create-mission-primary-content-container">
            <CreateMissionHeaderAndTitleRow title={"Mission Name"} subtitle="How should we display this mission to our users?" hidePrice={true} />
            <SessionDetailsForm>
                <div className="session-details-container">
                    {loadingMission ? <CenteredLoadingIcon /> :
                        (<>
                            <div className="session-details-form-container">
                                <FormField label="Public Project Name" name="name" id="name" placeholder="Crypto & Social Media Users" onChange={onMissionNameChange} tooltip={nameTooltip} type="text" value={missionName} />
                                <CommentField label="Public Audience Description" name="description" id="ndescriptionme" placeholder="Looking for users who are heavy DEX users." onChange={onMissionDescriptionChange} tooltip={descriptionTooltip} type="comment" value={missionDescription} />
                            </div>
                            <CreationFooter buttonText="Next" onClickBack={onClickBack} onClickSubmit={onClickSubmit} submitLoading={submitInProcess} />
                        </>
                        )}
                </div>
            </SessionDetailsForm>
        </div>


    )
}

function SessionDetailsForm(props) {
    return (
        <form className="session-details-form">
            {props.children}
        </form>
    )
}

export default MissionNameAndDetails;